export default __webpack_public_path__ + "static/20_32-6b4356badedda13428b1fc7fea6f484e.png";